import { FormGroup } from '@angular/forms';
import { FIREBASE_CONFIG_DEFAULT } from "src/app/core/constants/app-constants";
import { AppData } from '../services/app-data.service';


export function getFormValidation(formControl, fieldName, isSubmitted?) {
    if (formControl[fieldName].touched && formControl[fieldName].invalid && (formControl[fieldName].dirty || isSubmitted)) {
        return true;
    }
    return false;
}

// for get single group input filed validation
export function getInputFieldValidation(formName, fieldName, isSubmitted?) {
    if (formName.controls[fieldName].invalid && (formName.controls[fieldName].dirty || isSubmitted)) {
        return true;
    }
    return false;
}

// for get nested group input filed validation
export function getNestedGrpFieldValidation(formName, grpFieldName, fieldName, isSubmitted?) {
    if (formName.get(grpFieldName).get(fieldName).invalid && (formName.get(grpFieldName).get(fieldName).dirty || isSubmitted)) {
        return true;
    }
    return false;
}

// filter list 
export function filterDataList(tempList, fieldName, searchStr) {
    return tempList.filter((inputObj) => {
        return inputObj[fieldName].search(new RegExp(searchStr, 'i')) > -1;
    });
}


// custom validator to check that two fields match
export function mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function processTimeString(timeString) {
    let startDateHourString = timeString.substring(0, 2);
    const startDateMinString = timeString.substring(2, 4);
    let startDateAmPmString = 'AM';
    if (Number(startDateHourString) === 12) {
        startDateAmPmString = 'PM';
    } else if (Number(startDateHourString) > 12) {
        startDateHourString = Number(startDateHourString) - 12;
        startDateAmPmString = 'PM';
    } else if (Number(startDateHourString) > 24) {
        startDateHourString = Number(startDateHourString) - 24;
        startDateAmPmString = 'AM';
    }
    return (startDateHourString + ':' + startDateMinString + ' ' + startDateAmPmString);
}

//

export function onScrollHeaderFixed() {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop;
    const shrinkOn = 50;
    const headerEl = document.getElementById('header');
    if (distanceY - shrinkOn >= 100) {
        headerEl.classList.add('fixed');
    } else {
        headerEl.classList.remove('fixed');
    }
}

export function formatOfferDetails(offer, multipleKey = false) {
    let text = offer.value.toString();
    let upto = ''
    if (offer.discountType === 'net') {
        text = `Rs. ${text} OFF`;
    } else {
        text += '% OFF';
    }
    // if (offer.minOrderAmount && offer.minOrderAmount > 0) {
    //     text += ` on orders above ₹${offer.minOrderAmount}`;
    // }
    if (offer.maxDiscount && offer.maxDiscount > 0) {
        // text += ` upto ₹${offer.maxDiscount}`;
        upto = ` upto ₹${offer.maxDiscount}`;
    } else {
        text = `Flat ${text}`;
    }
    // text += '.';// Applies automatically in cart.
    if (multipleKey) {
        return { text, upto };
    } else {
        return text;
    }
}

export function getOutletOfferBasedOnTime(offerList, multipleKey = false) {
    if (offerList.length > 0) {
        const filteredList = getFilteredList(offerList);
        if (filteredList.length > 0) {
            return formatOfferDetails(getMaxOffer(filteredList), multipleKey);
        }
    }
    return '';
}

export function getSmallString(offerList , styleRequired = false) {
    if (offerList.length > 0) {
        const filteredList = getFilteredList(offerList);
        if (filteredList.length > 0) {
            return formatSMLOfferDetails(getMaxOffer(filteredList), styleRequired);
        }
    }
}


export function formatSMLOfferDetails(offer, styleRequired) {
    let text = offer.value.toString();
    let type = 'normal';
    if (offer.discountType === 'net') {
        text = `₹${text} OFF`;
    } else {
        text += '% OFF';
    }
    if (offer.maxDiscount && offer.maxDiscount > 0) {
    } else {
        if(styleRequired){
        type = 'flat';
        text = `<span class="sitefontextrabold" style="color: rgb(255, 165, 0);" >FLAT</span> <br> <span class="sitefontextrabold">${text}</span>`;
        }else{
            type = 'flat';
            text = `FLAT ${text}`;    
        }
    }
    return { text, type };
}

export function getFilteredList(offerList) {
    if (offerList.length > 0) {
        const filteredList = [];
        for (let i = 0; i < offerList.length; i++) {
            if (isOfferPresentWithinDate(offerList[i])) {
                filteredList.push(offerList[i]);
            }
        }
        return filteredList;
    }
    return [];
}

export function getMaxOffer(offerList) {
    let maxValue = offerList[0].value;
    let maxIndex = 0;
    for (let i = 1; i < offerList.length; i++) {
        if (offerList[i].value > maxValue) {
            maxValue = offerList[i].value
            maxIndex = i;
        }
    }
    return offerList[maxIndex];
}

export function makeCuisinesStr(cuisines, count = 4) {
    const cuisineStr = cuisines.slice(0, count).join(', ');
    // return cuisines.length > count ? cuisineStr + ',...' : cuisineStr;
    return cuisineStr;

}

export function makeCuisinesMoreThen3Str(cuisines) {
    const cuisineStr = cuisines.slice(0, 3).join(', ');
    return cuisines.length > 3 ? cuisineStr + ',...' : cuisineStr;
}


export function capitalizeFirstString(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function makeAddonsStr(addonsList) {
    let addonsText = ' ';
    addonsList.forEach(obj => {
        obj.options.map(opt => addonsText += opt.optionName + ', ');
    });
    const addonsStr = addonsText.substring(0, addonsText.length - 2);
    return addonsStr;
}

export function isOfferPresentWithinDate(offerList) {
    const today = new Date();
    const todayTime = String(today.getHours() < 10 ? `0${today.getHours()}` : today.getHours()) + String(today.getMinutes());

    if (today.toISOString() >= offerList.startDate && today.toISOString() <= offerList.endDate) {
        if (todayTime >= offerList.startTime && todayTime <= offerList.endTime) {
            return true;
        }
    }
    return false;
}

export async function copyTextToClipboard(text, clipboard?) {
    try {
        if (clipboard) {
            clipboard.copy(text);
        } else {
            await navigator.clipboard.writeText(`${text}`);
        }
    } catch (err) {
        return err;
    }
}

export function maxNumToBeAllowed(event, maxLen) {
    if (event.target.value.length >= maxLen) {
        return false;
    }
    return true;
}

export function dynamicFontSize(textLength) {
    const baseSize = 9;
    if (textLength >= baseSize) {
        textLength = baseSize - 2;
    }
    const fontSize = baseSize - textLength
    return `${fontSize}vw`;
}
export function getInviteMessage(userInfo) {

    return (`
Hey! I started saving more by ordering food from Yumzy. The best part is you win rewards on every order along with other deals💸.

If you're looking for the best prices on food delivery, then check out Yumzy! 👇
${userInfo.referralDeepLink}

Hit the link ➡ Use code: ${userInfo.referralCode} ➡ Sign up ➡ Enjoy
        `).replace(/(\n)[^\S\r\n]+/g, '$1');
}

export function getShareMessage(userInfo, amount) {

    return (`
    Hey look, I won credits worth ₹${amount} through Yumzy! The best part is you win rewards on every order along with other deals💸.

If you're looking for the best prices on food delivery, then check out Yumzy! 👇
${userInfo.referralDeepLink}

Hit the link ➡ Use code: ${userInfo.referralCode} ➡ Sign up ➡ Enjoy
        `).replace(/(\n)[^\S\r\n]+/g, '$1');
}

export function fetchOfferStyle() {
    console.log('offer display Type', AppData.firebaseRemoteConfig?.offer_display_type_v2);
    return AppData.firebaseRemoteConfig?.offer_display_type_v2
        ? JSON.parse(AppData.firebaseRemoteConfig?.offer_display_type_v2)
        : FIREBASE_CONFIG_DEFAULT.offer_display_type
}

export function getCouponSuggStr(coupons, itemTotal) {
    let couponStr = ''
    let prevApplied = true;
    let canApply = false;
    for (let i = 0; i < coupons.length; i++) {
        if (prevApplied) {
            console.log(coupons[i].minOrderAmount, itemTotal)
            if (couponStr == '') {
                if (coupons[i].minOrderAmount > itemTotal) {
                    couponStr = couponCanApply(coupons[i], itemTotal);
                    prevApplied = false;
                    canApply = false;
                    break;
                } else {
                    couponStr = couponApplied(coupons[i])
                    canApply = true;
                }
            } else {
                if (coupons[i].minOrderAmount < itemTotal) {
                    couponStr = couponApplied(coupons[i])
                    prevApplied = true;
                    canApply = true;
                } else {
                    if (coupons[i].minOrderAmount - itemTotal < 150 && coupons[i].minOrderAmount - itemTotal > 0) {
                        couponStr = couponCanApply(coupons[i], itemTotal);
                        canApply = false;
                        break;
                    }
                }


            }
        }
    }
    return { couponStr, canApply };

}

function couponCanApply(coupon, itemTotal) {
    let couponStr = `Add items worth ₹${coupon.minOrderAmount - itemTotal} to `;
    if (coupon.value && coupon.value.maxDiscountOptedV) {
        if (coupon.discountType === "percentage") {
            couponStr += `save upto <span class="coupoun-text-clr"> ₹${coupon.value.maxDiscount} | Code ${coupon.couponCode} </span>`
        }
    } else {
        if (coupon.discountType === "percentage") {
            couponStr += `unlock <span class="coupoun-text-clr"> flat ${coupon.value.discountValue}% off | Code ${coupon.couponCode}</span>`
        } else {
            couponStr += `save <span class="coupoun-text-clr"> flat ₹${coupon.value.discountValue} off | Code ${coupon.couponCode}</span>`
        }
    }
    return couponStr;
}
function couponApplied(coupon) {
    let couponStr = `<span class='fs-12'> ${coupon.couponCode}</span> coupon unlocked! Use it to `;
    if (coupon.value && coupon.value.maxDiscountOptedV) {
        if (coupon.discountType === "percentage") {
            couponStr += `save upto <span class="coupoun-text-clr"> ₹${coupon.value.maxDiscount}</span>.`
        }
    } else {
        if (coupon.discountType === "percentage") {
            couponStr += `unlock <span class="coupoun-text-clr"> flat ${coupon.value.discountValue}% off </span>.`
        } else {
            couponStr += `save <span class="coupoun-text-clr"> flat ₹${coupon.value.discountValue} off </span>.`
        }
    }
    return couponStr;
}